/**
 * @fileoverview Checks for line items that are considered to be 'errors' in
 * cart and should be adjusted or removed. File will only execute if cart page
 * is reloaded.
 * These include error cases:
 * Case 1: Bundle is missing '_bundle_reference' property and has price of 0.
 * Case 2: Bundle has incorrect quantity.
 * Case 3: Package protection has duplicate.
 */

async function lineItemCheck() {
	var cartContents = await fetch(window.theme.localeRootUrl + "/cart.js")
		.then((response) => response.json())
		.then((data) => {
			return data;
		});

	// Track ids of bundles.
	let bundleReferencers = {};
	cartContents.items.forEach((item) => {
		// Track quantity of bundles.
		if (item.properties["_bundle_reference"]) {
			bundleReferencers[item.properties["_bundle_reference"]] = {
				quantity: item.quantity,
				correctionKeys: [],
			};
		}

		// Check if bundle is missing '_bundle_reference' property and has price
		// of 0.
		if (
			item.product_type === "KS Bundle" &&
			Object.keys(item.properties).includes("_bundle_reference") === false &&
			item.price === 0
		) {
			updateItemQuantity([item.key]);
		}

		// Validated package protection to make sure that there is only one package
		// protection in cart.
		if (item.handle === "kiara-sky-package-protection" && item.quantity > 1) {
			updateItemQuantity([item.key], 1);
		}
	});

	// Check for bundle items that have incorrect quantity.
	cartContents.items.forEach((item) => {
		let bundleId =
			item.properties["_custom_bundle_id"] || item.properties["_bundle_id"];

		if (bundleId && item.quantity !== bundleReferencers[bundleId].quantity) {
			bundleReferencers[item.properties["_bundle_id"]].correctionKeys.push(
				item.key
			);
		}
	});

	// Update quantity of items that have incorrect quantity.
	for (let bundle in bundleReferencers) {
		const bundleCorrectionKeys = bundleReferencers[bundle].correctionKeys;
		if (bundleCorrectionKeys.length > 0) {
			updateItemQuantity(
				bundleCorrectionKeys,
				bundleReferencers[bundle].quantity
			);
		}
	}
}
lineItemCheck();

/**
 * Updates quantity of a line item in cart.
 * @param {string} bundleKeys - Line item keys to update.
 * @param {number} quantity - Quantity to update the line item to. Default is 0.
 */
async function updateItemQuantity(bundleKeys, quantity = 0) {
	let updates = {};

	bundleKeys.forEach((bundleKey) => {
		updates[bundleKey] = quantity;
	});

	await fetch(window.theme.localeRootUrl + "/cart/update.js", {
		method: "POST",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
			"X-Requested-With": "XMLHttpRequest",
		},
		body: JSON.stringify({
			updates: updates,
		}),
	}).then((response) => {
		if (response.ok) {
			document.documentElement.dispatchEvent(
				new CustomEvent("cart:refresh", {
					bubbles: true,
				})
			);
		} else {
			console.error("Error updating item in cart.");
		}
	});
}
